import React, { useState } from 'react';
import InputField from '../../../../component/form/FormInput';
import Button from '../../../../component/ui/Button';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { formatErrors } from '../../../../utils/controller';
import { shelf_create } from '../../../../store/action/shelf';

const Addshelf = ({ isOpen, onCLose, reloadTable, setAutoFocus, setPersistShelf, setShelf }) => {
	const dispatch = useDispatch();
	const [name, setName] = useState('');
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);

	const submitForm = (e) => {
		e.preventDefault();
		if (name !== '' && name !== undefined && name !== null) {
			if (!name.trim()) {
				setError('Shelf name is required');
				return;
			}

			setLoading(true);
			setError('');
			let body = {
				name: name,
			};
			dispatch(shelf_create(body))
				.then((res) => {
					setLoading(false);
					if (res?.success) {
						setPersistShelf(name);

						setAutoFocus({
							catogrey: false,
							product: false,
							shelf: false,
							tax1: true,
						});
						reloadTable();
						setShelf(res?.data?.shelf_id);
						toast.success(res?.message);
						onCLose();
					} else {
						formatErrors(res?.data?.message);
						toast.error(res?.response?.data?.message);
					}
				})
				.catch((err) => {
					setLoading(false);
				});
		} else {
			setError('Please enter name of shelf in the field');
		}
	};

	const changeName = (val) => {
		setName(val);

		if (val !== null && val !== '' && val !== undefined) {
			setError('');
		} else {
			setError('Please enter name of shelf in the field');
		}
	};

	return (
		<div>
			<form
				onSubmit={submitForm}
				className="add-productgroup-form"
			>
				<InputField
					label="Shelf Name"
					placeholder=""
					type="text"
					required={true}
					name="Enter Shelf Name"
					autoFocus={true}
					onChange={(val) => changeName(val)}
					value={name}
					error={error}
				/>
				<div className="add-productgroup-footer">
					<Button
						type="submit"
						button="Save"
						className="btn-primary add-pgroup"
						loader={loading}
						onClick={submitForm}
					/>
					<Button
						type="button"
						button="Cancel"
						className="btn-gray add-pgroup"
						onClick={onCLose}
					/>
				</div>
			</form>
		</div>
	);
};

export default Addshelf;
